<template>
  <div>
    <c-box
      title="Структура поискового трафика"
      header-divider
      :loading="loading"
      without-left-padding
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <span class="text-gray divider">|</span>
          <c-select
            v-if="Object.keys(monthsDatesFormated).length"
            v-model="monthDate"
            title="ДАННЫЕ ЗА ПЕРИОД:"
            form-group
            :options="monthsDatesFormated"
          />
          <div class="form-group">
            Диаграмма
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="diagram"
              >
            </label>
            Таблица
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="table"
              >
            </label>
          </div>
        </form>
      </template>

      <template v-if="!loading && monthlyReport.length">
        <table
          v-if="view === 'table'"
          class="table"
        >
          <thead>
            <tr>
              <th>Устройства входа</th>
              <th>Визиты</th>
              <th>Просмотры</th>
              <th>Отказы</th>
              <th>Время на сайте</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item of monthlyReport"
              :key="item.УстройстваВхода"
            >
              <td v-text="item.УстройстваВхода" />
              <td v-text="item.Визиты" />
              <td v-text="item.Просмотры" />
              <td v-text="item.Отказы" />
              <td v-text="item.ВремяСтрока" />
            </tr>
          </tbody>
        </table>
        <div
          v-else
          class="row"
        >
          <div class="col-md-7">
            <metrics-table :data="monthlyReport.map(i => ({name: i.УстройстваВхода, visits: i.Визиты}))" />
          </div>
          <div class="col-md-5">
            <c-doughnut-chart
              class="doughnut-chart"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </div>
      </template>
      <no-data v-if="!loading && !monthlyReport.length" />
    </c-box>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import MetricsTable from '../../../../../../../resources/js/components/MetricsTable.vue'
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import CDoughnutChart from '../../../../../../../resources/js/components/ui/CDoughnutChart.vue'
import { getMonthsFormated } from '../../../../../../../resources/js/helper'
import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'

const MONTH_DATE_FORMAT = 'YYYY-MM-DD'

export default {
  name: 'MetricTrafficDevices',
  components: { CDoughnutChart, MetricsTable, NoData, CBox, CSelect },
  mixins: [sengine, diagramColors],
  data () {
    return {
      view: 'table',
      monthDate: moment().subtract(1, 'months').startOf('month').format(MONTH_DATE_FORMAT),
      monthlyReport: [],
      loading: true,
      chartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          callbacks: {
            label (tooltipItem, data) {
              return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    /**
     * Элементы выпадающего списка с выбором периода (месяца).
     */
    monthsDatesFormated () {
      let dates = {}

      if (this.clientProjects.length) {
        dates = getMonthsFormated(this.clientProjects[0].work_start_date, moment().subtract(1, 'month'))
      }

      return dates
    },
    chartData () {
      return {
        labels: this.monthlyReport.map(i => i.УстройстваВхода),
        datasets: [
          {
            data: this.monthlyReport.map(i => i.ДоляВОбщемЧислеВизитов),
            backgroundColor: this.monthlyReport.map((item, index) => this.getNextDiagramColor(index))
          }
        ]
      }
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      clientProjects: state => state.seo.client.projects.projects
    })
  },
  watch: {
    monthDate () {
      this.fetchMonthlyReport()
    }
  },
  mounted () {
    if (this.domainSelected) {
      this.fetchMonthlyReport()
    }
    this.$root.$on('clientDomainsSelectedChange', this.fetchMonthlyReport)
  },
  destroyed () {
    this.$root.$off('clientDomainsSelectedChange', this.fetchMonthlyReport)
  },
  methods: {
    fetchMonthlyReport () {
      this.monthlyReport = []
      this.loading = true
      const month = 1 + moment(this.monthDate, MONTH_DATE_FORMAT).month()
      const year = moment(this.monthDate, MONTH_DATE_FORMAT).year()

      apiService.getReport(this.domainSelected, year, month)
        .then(response => {
          const report = response.data[0]
          this.monthlyReport = report ? report.ДанныеОтчета.ТаблицаУстройстваВхода || [] : []
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Структура поискового трафика. Не удалось загрузить ежемесячный отчет.'
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.divider {
  @media (max-width: $smBreakpoint) {
    display: none;
  }

  margin-right: 10px;
}
</style>
